/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import { seguridad } from '../../../modelos/conexiones';
import ModalCargo from '@infotrack/presentacion-modulosbase/modulos/Cargo/Cargos';

const Cargo: React.FunctionComponent = () => {
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    return <ModalCargo idEmpresa={idEmpresa} seguridad={seguridad} />;
};
export default Cargo;
